import { v4 as uuidv4 } from 'uuid';
import { getBrand } from './getBrand';

export function getDefaultRequestHeaderParams(extraHeaders?: any): any {
  return {
    'request-identifier': uuidv4(),
    application: 'LIVE_CHAT',
    brand: getBrand().name.toUpperCase(),
    channel: 'WEB',
    ...extraHeaders,
  };
}
